import React from 'react';
import './ComingSoon.css';

const ComingSoon = ({ title, subtitle = "We're building this now. It isn't available yet, but it will be soon." }) => {
    const navigate = (path) => {
        window.history.pushState({}, '', path);
        window.dispatchEvent(new PopStateEvent('popstate'));
    };
    return (
        <div className="coming-soon-page">
            <div className="coming-soon-content">
                <div className="coming-soon-badge">Coming Soon</div>
                <h1 className="coming-soon-title">{title}</h1>
                <p className="coming-soon-subtitle">{subtitle}</p>
                <div className="coming-soon-actions">
                    <button className="btn primary" onClick={() => navigate('/')}>Back to Home</button>
                    <button className="btn ghost" onClick={() => navigate('/blog')}>Read our Blog</button>
                </div>
            </div>
            <div className="coming-soon-glow" />
        </div>
    );
};

export default ComingSoon;
